/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import NotificationTemplateListLayout from './NotificationTemplateListLayout/NotificationTemplateListLayout';
import NotificationTemplateFormLayout from './NotificationTemplateFormLayout/NotificationTemplateFormLayout';
import { CrudStatus } from '../../../utility/types/CrudStatus';
import {
  fetchNotificationTemplates,
  selectNotificationTemplatesCrudStatus,
} from '../../../redux/slices/notificationTemplatesSlice/notificationTemplatesSlice';
import RaaRoute from '../../common/RaaRoute';

function NotificationTemplatesPage() {
  const dispatch = useDispatch();
  const crudStatus = useSelector(selectNotificationTemplatesCrudStatus);
  // const initialLoad = useSelector(selectNotificationTemplatesInitialLoad);
  useEffect(() => {
    if (crudStatus === CrudStatus.IDLE) {
      dispatch(fetchNotificationTemplates());
    }
  });

  if (crudStatus === CrudStatus.PENDING) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div><ProgressSpinner progressText="Loading..." /></div>
      </div>
    );
  }
  return (
    <Switch>
      <RaaRoute path="/s/actions/notification-templates" exact>
        <Redirect to="/s/actions/notification-templates/templates" />
      </RaaRoute>
      <RaaRoute path="/s/actions/notification-templates/templates" exact>
        <NotificationTemplateListLayout />
      </RaaRoute>
      <RaaRoute path="/s/actions/notification-templates/new" exact>
        <NotificationTemplateFormLayout />
      </RaaRoute>
      {' '}
      <RaaRoute
        path="/s/actions/notification-templates/edit/:notificationTemplateId"
        exact

        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const notificationTemplateId = parseInt(actionMatch.params.notificationTemplateId, 10);
          return <NotificationTemplateFormLayout notificationTemplateId={notificationTemplateId} />;
        }}
      />
      <RaaRoute
        path="/s/actions/notification-templates/clone/:notificationTemplateId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const notificationTemplateId = parseInt(actionMatch.params.notificationTemplateId, 10);
          return (
            <NotificationTemplateFormLayout
              notificationTemplateId={notificationTemplateId}
              clone
            />
          );
        }}
      />
    </Switch>
  );
}

export default NotificationTemplatesPage;
